import { render, staticRenderFns } from "./Setarea.vue?vue&type=template&id=23f53263&scoped=true"
import script from "./Setarea.vue?vue&type=script&lang=js"
export * from "./Setarea.vue?vue&type=script&lang=js"
import style0 from "./Setarea.vue?vue&type=style&index=0&id=23f53263&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f53263",
  null
  
)

export default component.exports